import type { EventsListResponse } from '@/types';
import { MentionsQueryParams } from '@/types/mention.types';
import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

export const mentionsApi = {
  /**
   * Get mentions events with filtering and pagination
   */
  getMentions: async (params?: MentionsQueryParams): Promise<EventsListResponse> => {
    const defaultParams: MentionsQueryParams = {
      limit: 20,
      offset: 0,
      order: 'createdAt',
      ascending: true,
      closed: false,
      active: true,
      tag_id: 100343,
    };

    const finalParams = { ...defaultParams, ...params };

    try {
      const response = await axiosClient.get<EventsListResponse>(
        API_ENDPOINTS.MARKETS_EVENTS_LIST,
        {
          params: finalParams,
        }
      );

      return response.data;
    } catch (error) {
      console.error('Failed to fetch mentions:', error);
      throw error;
    }
  },
};
